export class BancaTagUtils {
  private static readonly BANCA_TAG = '[BANCA]';

  static addBancaTag(descricao: string): string {
    if (this.isBancaActivity(descricao)) {
      return descricao;
    }
    return `${this.BANCA_TAG} ${descricao}`;
  }

  static removeBancaTag(descricao: string): string {
    return descricao.replace(this.BANCA_TAG, '').trim();
  }

  static isBancaActivity(descricao: string): boolean {
    return descricao.includes(this.BANCA_TAG);
  }

  static getBancaTag(): string {
    return this.BANCA_TAG;
  }
}